import {breakpointToViewportSizes} from "../../models/ViewportSize"

const breakpointToViewportSize = (breakpoint: string) => breakpointToViewportSizes[breakpoint] as string

export default breakpointToViewportSize
